export default function PrivacyToggle({ id, label, description, value, onChange, disabled = false }) {
  const labelId = `${id}-label`;
  const descriptionId = `${id}-description`;
  return (
    <div className={`privacy-toggle-row${disabled ? " is-disabled" : ""}`}>
      <div className="privacy-toggle-info">
        <div className="privacy-toggle-label" id={labelId}>{label}</div>
        <div className="privacy-toggle-desc" id={descriptionId}>{description}</div>
      </div>
      <label className="pill-toggle">
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          id={id}
          disabled={disabled}
          aria-labelledby={labelId}
          aria-describedby={descriptionId}
        />
        <span className="pill-toggle-track" />
        <span className="pill-toggle-thumb" />
      </label>
    </div>
  );
}
